<template>
  <div class="monitoringV2">
    <!-- 头部时间 -->

    <div class="title flexbox">
      <div class="fubiao">北礵三米测浪浮标</div>
      <div class="clock_bg"></div>
      <div class="timetext">时间</div>
      <div class="block">
        <el-date-picker
          v-model="value1"
          value-format="yyyy-MM-dd"
          type="datetimerange"
          :unlink-panels="true"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectTime"
        ></el-date-picker>
      </div>
    </div>
    <div class="flexbox">
      <div>
        <!-- 中部所有数据 -->
        <div class="allDate">
          <div class="frist flexbox">
            <div class="jingdu">
              <div class="jingdu_text">经度</div>
              <div class="jingdu_date">{{ listeqdata['经度'] }}</div>
            </div>
            <div class="weidu">
              <div class="weidu_text">纬度</div>
              <div class="weidu_date">{{ listeqdata['纬度'] }}</div>
            </div>
          </div>
          <div class="second flexbox">
            <div class="bogao3">
              <div class="bogao3_tetx">1/3波高（m）</div>
              <div class="bogao3_date">
                {{ Number(listeqdata['1/3波高']).toFixed(1) }}
              </div>
            </div>
            <div class="bozhouqi3">
              <div class="bogao3_tetx">1/3波周期（s）</div>
              <div class="bogao3_date">
                {{ Number(listeqdata['1/3波周期']).toFixed(1) }}
              </div>
            </div>
            <div class="bogao10">
              <div class="bogao3_tetx">1/10波高（m）</div>
              <div class="bogao3_date">
                {{ Number(listeqdata['1/10波高']).toFixed(1) }}
              </div>
            </div>
            <div class="bozhouqi10">
              <div class="bogao3_tetx">1/10波周期（s）</div>
              <div class="bogao3_date">
                {{ Number(listeqdata['1/10波周期']).toFixed(1) }}
              </div>
            </div>
          </div>
          <div class="third flexbox">
            <div class="bogao3">
              <div class="bogao3_tetx">最大波高（m）</div>
              <div class="bogao3_date">
                {{ Number(listeqdata['最大波高']).toFixed(1) }}
              </div>
            </div>
            <div class="bozhouqi3">
              <div class="bogao3_tetx">最大波周期</div>
              <div class="bogao3_date">
                {{ Number(listeqdata['最大波周期']).toFixed(1) }}
              </div>
            </div>
            <div class="bogao10">
              <div class="bogao3_tetx">平均波高（m）</div>
              <div class="bogao3_date">
                {{ Number(listeqdata['平均波高']).toFixed(1) }}
              </div>
            </div>
            <div class="bozhouqi10">
              <div class="bogao3_tetx">平均波周期</div>
              <div class="bogao3_date">
                {{ Number(listeqdata['平均波周期']).toFixed(1) }}
              </div>
            </div>
          </div>
          <div class="forth flexbox">
            <div class="boxiang">
              <div class="boxiang_text">波向（°）</div>
              <div class="boxiang_date">
                {{ Number(listeqdata['波向']).toFixed(1) }}
              </div>
            </div>
            <div class="qiya">
              <div class="boxiang_text">气压（hPa）</div>
              <div class="boxiang_date">
                {{ Number(listeqdata['气压(hPa)'] * 100000).toFixed(1) }}
              </div>
            </div>
            <div class="dianyazhi">
              <div class="boxiang_text">电压值（v）</div>
              <div class="boxiang_date">
                {{ Number(listeqdata['电压值']).toFixed(2) }}
              </div>
            </div>
          </div>
        </div>
        <!-- 左侧折线图 -->
        <div id="leftEchart">
          <div id="middleChart" v-if="showchart"></div>
        </div>
      </div>
      <!-- 右侧波向、时间 -->
      <div>
        <div class="righttop flexbox">
          <!-- <div class="boxiang">
            <div class="boxiang_text">波向</div>
            <div
              class="boxiang_bg"
              :style="{ transform: 'rotate(' + (bxright - 100) + 'deg)' }"
            ></div>
            <div class="boxiang_number">{{ bxright }}°</div>
          </div> -->
          <div class="shijain">
            <div class="shijain_text">时间</div>
            <div class="shijain_bg">
              <div class="shijian_time">{{ newtimert }}</div>
            </div>
          </div>
        </div>
        <div id="rightmiddle2">
          <div id="middleChart2" v-if="showchart"></div>
        </div>
        <div id="rightmiddle">
          <div id="middleChart3" v-if="showchart"></div>
        </div>
      </div>
    </div>
    <div class="rightbottom">
      <!-- 修改版 start -->
      <div class="table34">
        <table class="maxdata" cellspacing="0">
          <tr>
            <td class="title24hleft space" style="border-top-left-radius: 0.2px">24h最大</td>
            <td class="title3word space">最大风速(m/s)</td>
            <td class="title3word space">风向(°)</td>
            <td class="title24hleft space">24h最大</td>
            <td class="title3word space">最大波高(m)</td>
            <td class="title3word space">波周期(s)</td>
            <td class="title3word space">波向(°)</td>
            <!-- <td class="title3word space">时间</td> -->
          </tr>
          <tr>
            <td class="title24hleft">风速</td>
            <td class="title24h">{{ zdfs }}</td>

            <td class="title24h">{{ zdfx }}</td>
            <td class="title24hleft">波高</td>
            <td class="title24h">{{ zdbg }}</td>
            <td class="title24h">{{ zdbzq }}</td>
            <td class="title24h">{{ bxright }}</td>
            <!-- <td class="title24h">{{ title3time }}</td> -->
          </tr>
        </table>

        <div class="heng"></div>
        <table border="0" class="table30">
          <tr class="table41 space">
            <td class="table301">最新</td>
            <td class="table301">时间</td>
            <td class="table301">风速(m/s)</td>
            <td class="table301">风向(°)</td>
            <td class="table301">1/3波高(m)</td>
            <td class="table301">1/3波周期(s)</td>
            <td class="table301">波向(°)</td>
          </tr>
          <tr v-for="(max1, index) in listrev" :key="max1.id" :value="max1">
            <td class="table311">{{ index + 1 }}</td>
            <td class="table321">
              {{ moment(max1['时间']).format('YYYY-MM-DD HH:mm:ss') }}
            </td>
            <td class="table321">
              {{ Number(max1['风速']).toFixed(1) }}
            </td>
            <td class="table321">
              {{ Number(max1['风向']).toFixed(1) }}
            </td>
            <td class="table321">
              {{ Number(max1['1/3波高']).toFixed(2) }}
            </td>
            <td class="table321">
              {{ Number(max1['1/3波周期']).toFixed(1) }}
            </td>
            <td class="table321">
              {{ Number(max1['波向']).toFixed(1) }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 修改版 end -->

      <!-- 时间波向部分 -->
    </div>
    <div class="top"></div>
  </div>
</template>
<script>
import moment from 'moment'
//import '../assets/resize'
// 导入接口
import { bigfloater2, login } from '../service/getData'
const echarts = require('echarts')
import windLevel from './wind'
import { setToken, setUser } from '../utils/auth'
let intervalID
export default {
  data() {
    return {
      //时间
      value1: [
        //格式化选择的开始时间，当前时间的一年前
        moment().subtract(1, 'month').format('YYYY-MM-DD 00:00:00'),
        //选择的当前时间
        moment(moment().add(1, 'day')).format('YYYY-MM-DD 00:00:00'),
      ],
      configList: null,
      listeqdata: {},
      listchart: null,
      listchart1: null,
      windLevel: windLevel,
      equipid: null,
      // 通过query 传递的 equipid
      boxiangList: null,
      boxiangCount: 0,
      moment: moment,
      showchart: true,
      listrev: null,
      bxright: null,
      fx: null,
      fxleft: null,
      fs: null,
      fxnote: null,
      title3time: null,
      number: 1000,
      listJd: null,
      zdfs: null,
      zdfx: null,
      zdbg: null,
      zdbzq: null,
      zdbx: null,
      newtimert: null,
      toptimebegin: null,
      bdt: null || moment().subtract(1, 'month').format('YYYY-MM-DD 00:00:00'),
      edt: null || moment().add(1, 'day').format('YYYY-MM-DD 00:00:00'),
      isActive: false,
      eqiyaStatus: true,
      ebogaoStatus: false,
      ewenduStatus: false,
      ebozouqiStatus: false,
      data4: '',
      bigdate: [],
      index: 0,
    }
  },
  methods: {
    //选择时间
    async selectTime(time) {
      if (time != null && time.length != 0) {
        this.bdt = time[0]
        this.edt = time[1]
      }
      await this.table()
      await this.draw()
      await this.draw2()
      await this.draw3()
    },
    //表格的数据
    async table() {
      let res3 = await bigfloater2(this.equipid, this.number, this.bdt, this.edt)
      let data = res3.data.AppendData
      console.log('data>>>', data)
      let data2 = res3.data.AppendData.eqmax
      let listWind = JSON.parse(data2)
      let listwindDtl = listWind[0]
      //最大风速里面的风向
      let fxOffs = JSON.parse(res3.data.AppendData.fsmax)[0]
      console.log('fxOffs,', fxOffs)
      let obj1 = []
      for (let i in listwindDtl) {
        obj1.push(listwindDtl[i])
      }
      console.log('obj1>>>', obj1)
      // 根据下标找到值后渲染在页面中
      let zdfscut = obj1[0]
      this.zdfs = Number(zdfscut).toFixed(1)
      if (fxOffs !== undefined) {
        this.zdfx = Number(fxOffs.风向).toFixed(1)
      }
      // let zdfxcut = obj1[5]

      let zdbgcut = obj1[10]
      this.zdbg = Number(zdbgcut).toFixed(2)
      let zdbzqcut = obj1[11]
      this.zdbzq = Number(zdbzqcut).toFixed(1)
      let zdbxcut = obj1[3]
      this.zdbx = Number(zdbxcut).toFixed(1)
      let data3 = res3.data.AppendData.eqhistory

      //let listchart = JSON.parse(data3)
      //表格里最近最新五条的数据
      this.listchart1 = JSON.parse(data3)
      this.listrev = this.listchart1 && this.listchart1.reverse().slice(0, 5)
    },
    //折线图
    async draw() {
      let middleChart = echarts.init(document.getElementById('middleChart'))
      let res3 = await bigfloater2(this.equipid, this.number, this.bdt, this.edt)
      let data = res3.data.AppendData.eqdata
      this.boxiangList = res3.data.AppendData
      this.boxiangCount = [].concat(this.boxiangList.eqboxiang1, this.boxiangList.eqboxiang2, this.boxiangList.eqboxiang3).reduce((a, b) => {
        return a + b
      }, 0)
      let listJd = JSON.parse(data)
      let listjdDtl = listJd[0]
      this.listeqdata = listjdDtl

      let obj = []
      for (let i in listjdDtl) {
        obj.push(listjdDtl[i])
      }

      let fxcut = obj[15]
      this.fxleft = Number(fxcut).toFixed(0)
      let fengxiangcut = obj[15]
      this.fx = Number(fengxiangcut).toFixed(1)
      let fengsucut = obj[6]
      this.fs = Number(fengsucut).toFixed(1)

      // this.title3time = moment(obj[1]).format('YYYY/MM/DD HH:mm:ss')

      // let bxcut = obj1[3]
      // this.bxright = Number(bxcut).toFixed(0)
      //最大波向
      this.bigdate = []
      for (let i = 0; i < 16; i++) {
        let a =
          this.boxiangList.eqboxiang1[i] +
          this.boxiangList.eqboxiang2[i] +
          this.boxiangList.eqboxiang3[i] +
          this.boxiangList.eqboxiang4[i] +
          this.boxiangList.eqboxiang5[i] +
          this.boxiangList.eqboxiang6[i] +
          this.boxiangList.eqboxiang7[i] +
          this.boxiangList.eqboxiang8[i] +
          this.boxiangList.eqboxiang9[i] +
          this.boxiangList.eqboxiang10[i]
        this.bigdate.push(a)
      }
      let max = this.bigdate[0]
      //声明了个变量 保存累计次数最多的风向的下标值
      this.index = 0
      for (var i = 0; i < this.bigdate.length; i++) {
        if (max < this.bigdate[i]) {
          max = this.bigdate[i]
          this.index = i
        }
      }
      console.log('index', this.index)
      this.bxright = Number(this.index * 22).toFixed(0)
      let data3 = res3.data.AppendData.eqhistory
      this.data4 = res3.data.AppendData.eqparam
      console.log('data3>>>>', data3 == '""')
      if (data3 !== '""') {
        this.listchart = JSON.parse(data3).reverse()
      }

      var m = {}
      this.data4.map((item) => {
        this.listchart &&
          this.listchart.map((data5) => {
            if (m[item.paramnm] instanceof Array) {
              console.log('')
            } else {
              m[item.paramnm] = []
            }
            m[item.paramnm].push([moment(data5['时间']).format('YYYY-MM-DD HH:mm:ss'), data5[item.paramnm]])
          })
      })
      let mparamnm = []
      for (let a in m) {
        mparamnm.push(m[a])
      }
      console.log('mparamnm>>', mparamnm)
      let betime = []
      for (let i in this.listchart) {
        betime.push(this.listchart[i])
      }

      let benewtime = betime
      let righttime = []
      for (let c in benewtime[0]) {
        righttime.push(benewtime[0][c])
      }
      this.newtimert = moment(righttime[1]).format('YYYY-MM-DD HH:mm:ss')

      let topbgtime = benewtime[benewtime.length - 1]
      let topendtime = []
      for (let d in topbgtime) {
        topendtime.push(topbgtime[d])
      }
      this.toptimebegin = topendtime[1]
      let option = {
        legend: {
          left: '40%',
          textStyle: {
            color: 'rgba(169,169,169,1)',
            fontWeight: 500,
            fontFamily: 'NotoSansHans-Medium',
            fontSize: 10,
            lineHeight: 11,
          },

          data: [
            {
              icon: 'circle',
              name: '气压',
            },
            {
              icon: 'circle',
              name: '波高',
            },
            {
              icon: 'circle',
              name: '温度',
            },
            {
              icon: 'circle',
              name: '波周期',
            },
          ],
          selected: JSON.parse(localStorage.getItem('userConfig')),
        },
        grid: {
          left: '8%',
          top: '12%',
          right: '2%',
          //bottom:'8%'
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: true,
          },

          boundaryGap: false,
          nameTextStyle: {
            fontSize: 7,
            fontFamily: 'NotoSansHans-Medium',
            fontWeight: 500,
            color: 'rgba(150,150,150,1)',
          },
          splitNumber: 14,
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          min: 'dataMin',
          splitLine: {
            // show: true,
            lineStyle: {
              type: 'dashed',
            },
          },
        },
        series: [
          {
            showSymbol: false,
            name: '气压',
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7',
            },
            data: mparamnm[1],
            lineStyle: {
              color: '#36CFC9',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10,
            },
            itemStyle: {
              color: '#36CFC9',
            },
          },
          // 波高
          {
            showSymbol: false,
            name: '波高',
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7',
            },
            data: mparamnm[6],
            lineStyle: {
              color: '#A26DEB',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10,
            },
            itemStyle: {
              color: '#A26DEB',
            },
          },
          // 温度
          // {
          //   showSymbol: false,
          //   name: '温度',
          //   type: 'line',
          //   smooth: true,
          //   areaStyle: {
          //     color: '#e0e7f7'
          //   },
          //   data: mparamnm[3],
          //   lineStyle: {
          //     color: '#F759AB',
          //     shadowColor: '#bdbdbd',
          //     shadowOffsetX: 5,
          //     shadowBlur: 10
          //   },
          //   itemStyle: {
          //     color: '#F759AB'
          //   }
          // },
          //波周期
          {
            showSymbol: false,
            name: '波周期',
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7',
            },
            data: mparamnm[4],
            lineStyle: {
              color: '#FFF566',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10,
            },
            itemStyle: {
              color: '#FFF566',
            },
          },
        ],
      }
      middleChart.setOption(option)
      // 图例开关的行为只会触发 legendselectchanged 事件
      middleChart.on('legendselectchanged', function (params) {
        localStorage.setItem('userConfig', JSON.stringify(params.selected))
        this.configList = params
      })
    },
    async draw2() {
      let _this = this
      let middleChart = echarts.init(document.getElementById('middleChart2'))
      let data = {
        x: [],
        d: [],
      }
      let i = 0
      while (i < 16) {
        data.x.push(`${i * 22.5}`)
        data.d.push((Math.random() * 100) | 0)
        i++
      }
      console.log('data>>>>', data)

      middleChart.setOption({
        radiusAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} 次',
          },
        },
        polar: {},
        color: ['#467fff', '#FF7A45', '#FFF566', '#e62f2f', '#6cf57d', '#9a249c', '#689c24', '#1a2465', '#b98941', '#456316'],
        title: {
          // text: '波向统计'
        },
        legend: {
          data: ['波高0~1米', '波高1~2米', '波高2~3米', '波高3~4米', '波高4~5米', '波高5~6米', '波高6~7米', '波高7~8米', '波高8~9米', '波高9~10米'],
          top: -5,
          type: 'scroll',
        },
        tooltip: {
          formatter: function (params) {
            console.log('params', params)
            return `
            24小时风向共 ${_this.listchart.length} 次，${params.name} ° 区域 ${params.value} 次
            `
          },
        },
        angleAxis: {
          type: 'category',
          data: data.x,
          z: 10,
        },

        series: [
          // 风向
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang1,
            coordinateSystem: 'polar',
            name: '波高0~1米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang2,
            coordinateSystem: 'polar',
            name: '波高1~2米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang3,
            coordinateSystem: 'polar',
            name: '波高2~3米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang4,
            coordinateSystem: 'polar',
            name: '波高3~4米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang5,
            coordinateSystem: 'polar',
            name: '波高4~5米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang6,
            coordinateSystem: 'polar',
            name: '波高5~6米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang7,
            coordinateSystem: 'polar',
            name: '波高6~7米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang8,
            coordinateSystem: 'polar',
            name: '波高7~8米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang9,
            coordinateSystem: 'polar',
            name: '波高8~9米',
            stack: 'a',
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang10,
            coordinateSystem: 'polar',
            name: '波高9~10米',
            stack: 'a',
          },
        ],
      })
    },

    // 风向玫瑰图
    async draw3() {
      let _this = this
      let middleChart = echarts.init(document.getElementById('middleChart3'))
      let data = {
        x: [],
        d: [],
      }
      let i = 0
      while (i < 16) {
        data.x.push(`${i * 22.5}`)
        data.d.push((Math.random() * 100) | 0)
        i++
      }
      // this.wind_series_data()
      middleChart.setOption({
        radiusAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} 次',
          },
        },
        polar: {},
        color: [
          '#467fff',
          '#FF7A45',
          '#FFF566',
          '#e62f2f',
          '#6cf57d',
          '#9a249c',
          '#689c24',
          '#1a2465',
          '#b98941',
          '#798013',
          '#651380',
          '#bf4e82',
          '#631616',
          '#f56c6c',
          '#bdbf4e',
          '#456316',
        ],
        title: {
          // text: '波向统计'
        },
        // grid: {
        //   x: 0,
        //   y: 0
        // },
        legend: {
          top: -5,
          // orient: '',
          data: _this.windLevel.map((n) => n.name),
          type: 'scroll',
        },
        tooltip: {
          formatter: function (params) {
            console.log('params', params)
            return `
            24小时风向共 ${_this.listchart.length} 次，${params.name} ° 区域 ${params.seriesName} ${params.value} 次
            `
          },
        },
        angleAxis: {
          boundaryGap: false,
          type: 'category',
          data: data.x,
          z: 10,
        },
        series: this.wind_series_data(),
      })
    },
    // 风力风向数据
    wind_series_data() {
      let wind_level = {}
      for (let i = 0; i < 17; i++) {
        wind_level[i] = Array(17)
        wind_level[i].fill(null)
      }
      if (this.listchart) {
        this.listchart.map((w) => {
          // 获取风力描述
          let wind = this.getLevel(w.风速)
          // debugger
          if (!(wind_level[wind.level][(w.风向 / 22.5) | 0] instanceof Array)) wind_level[wind.level][(w.风向 / 22.5) | 0] = []
          wind_level[wind.level][(w.风向 / 22.5) | 0].push({
            ...wind,
            ...w,
          })
        })
      }

      let chartsData = Object.values(wind_level).map((w) => w.map((n) => (n instanceof Array ? n.length : 0)))
      return chartsData.map((n, index) => ({
        type: 'bar',
        data: n,
        coordinateSystem: 'polar',
        name: this.windLevel.find((n) => n.level === index).name,
        stack: 'a',
      }))
    },
    // 获取风力级别
    getLevel(speed) {
      // 解决 0.2987 => 0.2
      let sp = ((speed * 10) | 0) / 10
      let level = 0
      if ((sp >= 0) & (sp <= 0.2)) {
        level = 0
      } else if ((sp >= 0.3) & (sp <= 1.5)) {
        level = 1
      } else if ((sp >= 1.6) & (sp <= 3.3)) {
        level = 2
      } else if ((sp >= 3.4) & (sp <= 5.4)) {
        level = 3
      } else if ((sp >= 5.5) & (sp <= 7.9)) {
        level = 4
      } else if ((sp >= 8.0) & (sp <= 10.7)) {
        level = 5
      } else if ((sp >= 10.8) & (sp <= 13.8)) {
        level = 6
      } else if ((sp >= 13.9) & (sp <= 17.1)) {
        level = 7
      } else if ((sp >= 17.2) & (sp <= 20.7)) {
        level = 8
      } else if ((sp >= 20.8) & (sp <= 24.4)) {
        level = 9
      } else if ((sp >= 24.5) & (sp <= 28.4)) {
        level = 10
      } else if ((sp >= 28.5) & (sp <= 32.6)) {
        level = 11
      } else if ((sp >= 32.7) & (sp <= 36.9)) {
        level = 12
      } else if ((sp >= 37.0) & (sp <= 41.4)) {
        level = 13
      } else if ((sp >= 41.5) & (sp <= 46.1)) {
        level = 14
      } else {
        level = 15
      }

      return this.windLevel.find((n) => n.level === level)
    },
  },
  async mounted() {
    let result = await login('hy_zs', 'Asdf1234!')
    setToken(result.data.AppendData)
    setUser('hy_zs')

    this.equipid = 26
    await this.table()
    await this.draw()
    await this.draw2()
    await this.draw3()
    localStorage.clear()
    if (!localStorage.getItem('userConfig')) {
      let userConfig = {
        气压: this.eqiyaStatus,
        波高: this.ebogaoStatus,
        温度: this.ewenduStatus,
        波周期: this.ebozouqiStatus,
      }
      this.configList = userConfig
      localStorage.setItem('userConfig', JSON.stringify(userConfig))
    }
    intervalID = setInterval(() => {
      console.log('定时器开始')
      this.data4 = null
      this.listchart = null
      this.table()
      this.draw()
    }, 30000)
    setInterval(() => {
      window.location.reload()
    }, 840000)
  },
  destroyed() {
    clearInterval(intervalID)
  },
}
</script>
<style lang="scss" scoped>
.flexbox {
  display: flex;
}
.heng {
  width: 988px;
  height: 1.5px;
  background-color: rgba(145, 181, 235, 0.894);
}
.monitoringV2 {
  height: 1920px;
  width: 1080px;
  .top {
    margin-top: 20px;
    width: 1080px;
    height: 480px;
    background-image: url('~@/assets/images/bg1.png');
    background-size: 100% 100%;
  }
  .title {
    padding-top: 10px;
    .fubiao {
      width: 368px;
      height: 61px;
      background: #5c97fd;
      border-radius: 0px 35px 0px 35px;
      margin-left: 26px;
      margin-top: 20px;
      color: white;
      line-height: 61px;
      text-align: center;
      font-size: 30px;
    }
    .clock_bg {
      background-image: url('~@/assets/images/xingzhuang.png');
      width: 50px;
      height: 50px;
      background-size: 100% 100%;
      margin-left: 45px;
      margin-top: 25px;
    }
    .timetext {
      margin-left: 15px;
      margin-top: 34px;
      font-size: 22px;
    }
    .block {
      width: 200px;
      margin-left: 15px;
      margin-top: 35px;
    }
  }
  .allDate {
    .frist {
      margin-top: 20px;
      .jingdu {
        width: 250px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 30px;
        font-size: 16px;
        .jingdu_text {
          text-align: center;
          margin-top: 10px;
        }
        .jingdu_date {
          text-align: center;
          margin-top: 5px;
          font-weight: bold;
          font-size: 22px;
        }
      }
      .weidu {
        width: 250px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 80px;
        font-size: 16px;
        .weidu_text {
          text-align: center;
          margin-top: 10px;
        }
        .weidu_date {
          text-align: center;
          margin-top: 5px;
          font-weight: bold;
          font-size: 22px;
        }
      }
    }
    .second {
      margin-top: 30px;
      .bogao3_tetx {
        font-size: 16px;
        text-align: center;
        margin-top: 10px;
      }
      .bogao3_date {
        text-align: center;
        margin-top: 5px;
        font-weight: bold;
        font-size: 22px;
      }
      .bogao3 {
        width: 130px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 30px;
      }
      .bozhouqi3 {
        width: 130px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 15px;
      }
      .bogao10 {
        width: 130px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 15px;
      }
      .bozhouqi10 {
        width: 130px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 15px;
      }
    }
    .third {
      margin-top: 30px;
      .bogao3_tetx {
        font-size: 16px;
        text-align: center;
        margin-top: 10px;
      }
      .bogao3_date {
        text-align: center;
        margin-top: 5px;
        font-weight: bold;
        font-size: 22px;
      }
      .bogao3 {
        width: 130px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 30px;
      }
      .bozhouqi3 {
        width: 130px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 15px;
      }
      .bogao10 {
        width: 130px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 15px;
      }
      .bozhouqi10 {
        width: 130px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 15px;
      }
    }
    .forth {
      margin-top: 30px;
      .boxiang_text {
        font-size: 16px;
        text-align: center;
        margin-top: 10px;
      }
      .boxiang_date {
        text-align: center;
        margin-top: 5px;
        font-weight: bold;
        font-size: 22px;
      }
      .boxiang {
        width: 163px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 30px;
      }
      .qiya {
        width: 163px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 42px;
      }
      .dianyazhi {
        width: 163px;
        height: 72px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px #cbdffe;
        border-radius: 19px;
        opacity: 0.49;
        border: 4px solid #5c97fd;
        margin-left: 42px;
      }
    }
  }
  #leftEchart {
    width: 640px;
    height: 459px;
    margin-top: 40px;
    margin-left: 10px;
    #middleChart {
      width: 100%;
      height: 459px;
    }
  }
  .righttop {
    margin-left: 80px;
    .boxiang {
      .boxiang_text {
        font-size: 16px;
        margin-left: 60px;
      }
      .boxiang_bg {
        width: 158px;
        height: 158px;
        background-image: url('~@/assets/images/bg-boxiang.png');
        background-size: 100% 100%;
      }
      .boxiang_number {
        width: 50px;
        height: 20px;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        position: absolute;
        margin-left: 55px;
        margin-top: -95px;
      }
    }
    .shijain {
      margin-left: 40px;
      .shijain_text {
        font-size: 16px;
        margin-left: 60px;
      }
      .shijain_bg {
        width: 146px;
        height: 77px;
        background: #ffffff;
        box-shadow: 0px 0px 17px 0px #cbdffe;
        border-radius: 20px;
        opacity: 0.49;
        border: 3px solid #5c97fd;
        margin-top: 30px;
        margin-left: 5px;
        .shijian_time {
          text-align: center;
          font-size: 19px;
          font-weight: bold;
          margin-top: 20px;
        }
      }
    }
  }
  #rightmiddle {
    width: 380px;
    height: 350px;
    margin-top: 20px;
    margin-left: 20px;
    #middleChart3 {
      width: 380px;
      height: 350px;
    }
  }
  #rightmiddle2 {
    width: 380px;
    height: 350px;
    margin-top: 20px;
    margin-left: 15px;
    #middleChart2 {
      width: 380px;
      height: 300px;
    }
  }
  .rightbottom {
    display: flex;
    margin-bottom: 0.26px;
  }
  .table34 {
    width: 988px;
    height: 325px;
    margin-left: 40px;
    border-radius: 20px;
    border: 2px solid rgba(145, 181, 235, 0.894);
    margin-top: 5px;
  }
  .maxdata {
    width: 98%;
    height: 62px;
    border-radius: 20px;
    margin-left: 10px;
    //border-radius: 0.2px;
  }
  .title24hleft {
    height: 31px;
    font-size: 13px;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    line-height: 35px;
    text-align: center;
    background: #d4e8ff;
  }
  .space {
    white-space: nowrap;
  }
  .title3word {
    font-size: 12px;
    font-weight: bold;
    color: rgba(92, 92, 92, 1);
    line-height: 35px;
    text-align: center;
    width: 12.5%;
  }
  .title24h {
    font-size: 13px;
    font-family: NotoSansHans-Bold;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    margin-top: 2px;

    text-align: center;
  }
  .table30 {
    //border: 0.01px solid #dcdcdc;
    height: 208px;
    width: 100%;
    //margin-top: 0.1px;
    border-collapse: collapse;
  }

  .table31 {
    background: rgba(212, 232, 255, 0.8);
  }

  .table311 {
    text-align: center;
    font-size: 10px;
    font-family: NotoSansHans-Medium;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    line-height: 25px;
    //border-right: 0.01px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
  }
  .table301 {
    text-align: center;
    font-size: 10px;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    line-height: 25px;
    vertical-align: top;
  }
  .table321 {
    //width: 25%;
    white-space: nowrap;
    //border-right: 0.01px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    text-align: center;
    font-size: 12px;
    color: rgba(135, 135, 135, 1);
    // padding-top: 75px;
    // padding-bottom: 75px;
  }
  .table6 {
    margin-left: 40px;
    margin-top: 20px;
  }
  .table6time {
    height: 78px;
    width: 116px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 17px 0px rgba(203, 223, 254, 1);
    border-radius: 20px;
    border: 3px solid #cbdffe;
    margin-top: 10px;
    margin-left: 20px;
  }
  .shijian {
    text-align: center;
    font-size: 17px;
    font-family: NotoSansHans-Medium;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
    line-height: 27px;
    margin-left: 20px;
  }
  .time1 {
    text-align: center;
    font-size: 17px;
    font-family: NotoSansHans-Regular;
    font-weight: bold;
    color: #394446;
    line-height: 20px;
    margin-top: 17px;
  }
  .time2 {
    font-size: 20px;
    text-align: center;
    font-family: NotoSansHans-Medium;
    font-weight: bold;
    color: rgba(38, 38, 38, 1);
    line-height: 10px;
  }
}
</style>
